module.exports = __webpack_public_path__ + "img/logo.69fd08fd.png";